module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Life is neither good or evil, but only a place for good and evil.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("—Marcus Aurelius.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47d19d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/006.vue
// module id = 69
// module chunks = 0